<template>
  <div class="redirect-page col-block" :style="{ minHeight: minHeight }">
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { postConfirmEmail } from '../../api'
import loginMethods from '../../mixins/loginData'
import toastMethods from '../../mixins/toastMethods'

export default {
  mixins: [
    loginMethods,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      data: {
        user_id: '',
        confirm_email_token: ''
      }
    }
  },
  async created () {
    if (this.$route.query.user_id && this.$route.query.confirm_email_token) {
      this.setLoadingAction(true)
      this.data.user_id = this.$route.query.user_id - 0
      this.data.confirm_email_token = this.$route.query.confirm_email_token
      await this.confirmEmail()
      this.setLoadingAction(false)
      switch (this.$route.params.type) {
        case 'register': {
          this.setUserData(null)
          this.$router.push({ name: 'main' })
          break
        }
        default: {
          this.$router.push({ name: 'main' })
        }
      }
    } else {
      this.$router.push({ name: 'main' })
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction'
    ]),
    async confirmEmail () {
      try {
        let data = this.data
        await postConfirmEmail(data)
        this.addToast('success', '註冊成功</br>請至APP內登入')
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.setLoadingAction(false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/redirect.vue